import React from "react";

import { apolloClientWithAuth0 as getEmployerClient } from "~/../employer-ui/src/lib/graphql/graphql";
import { apolloClientWithAuth0 as getTrackyrClient } from "~/../trackyr-ui/src/lib/graphql";
import {
  apolloClientWithAuth0 as getFederationGatewayClient,
  getPublicFederationClient,
} from "~/lib/federationGateway/client";

import { env } from "~/env";
import { useApolloClient } from "~/hooks/useApolloClient";
import { useApolloClients, ApolloClientsContext } from "./ApolloClients";

type ProviderProps = {
  children: React.ReactNode;
};

export const ApolloClientsProvider = ({ children }: ProviderProps) => {
  const employerClient = getEmployerClient();

  const engageClient = useApolloClient({
    uri: `${env.ENGAGE_API_URL}/graphql`,
  });

  const shortlysterClient = useApolloClient({
    uri: `${env.SHORTLYSTER_API_URL}/graphql`,
  });

  const trackyrClient = getTrackyrClient({
    uri: `${env.TRACKYR_API_URL}/graphql`,
  });

  const federationGatewayClient = getFederationGatewayClient();
  const publicFederationGatewayClient = getPublicFederationClient();

  return (
    <ApolloClientsContext.Provider
      value={{
        employerClient,
        engageClient,
        shortlysterClient,
        trackyrClient,
        federationGatewayClient,
        publicFederationGatewayClient,
      }}
    >
      {children}
    </ApolloClientsContext.Provider>
  );
};

export { useApolloClients };
